import { render, staticRenderFns } from "./_TravelDocumentType.vue?vue&type=template&id=58cafb40&"
import script from "./_TravelDocumentType.vue?vue&type=script&lang=ts&"
export * from "./_TravelDocumentType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports